import React from 'react';
import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import DesignsTray from './DesignsTray';
import ProductTray from './ProductTray';
import WallTextureTray from './WallTextureTray';
import LightingTray from './LightingTray';
import FloorTextureTray from './FloorTextureTray';
import DoorsAndWindowsTray from './DoorsAndWindowsTray';
import WallColorPicker2 from './WallColorPicker2';

// Define the type for tabsMap
export interface TabInfo {
  icon: JSX.Element;
  iconActive: JSX.Element;
  tray: JSX.Element;
  label: string;
}

// Helper function for generating icons
const createIcon = (isActive: boolean) => (
  <SquareRoundedIcon
    fontSize="large"
    style={{ color: isActive ? 'primary' : 'black', fontSize: '35px' }}
  />
);

// Helper function to generate tray components with parameters for ProductTray
const createTray = (
  tab: string,
  applyFloorTexturein3DView: Function,
  applyFloorTexturein2DView: Function,
  updateWallColor: Function,
  applyColorTo2DWall: Function,
  productType: string,
  productId: string,
  includeRecommendations: boolean,
  builderType: string
) => {
  switch (tab) {
    case 'designTab':
      return <DesignsTray builderType={builderType} />;
    case 'furnitureTab':
      return <ProductTray productType={productType} productId={productId} includeRecommendations={includeRecommendations} />;
    case 'wallsTab':
      return <WallTextureTray />;
    case 'lightingTab':
      return <LightingTray />;
    case 'floorTab':
      return <FloorTextureTray applyTexture={applyFloorTexturein3DView} />;
    case 'doorsTab':
      return <DoorsAndWindowsTray type="door" />;
    case 'windowsTab':
      return <DoorsAndWindowsTray type="window" />;
    case 'wallColorTab':
      return <WallColorPicker2 updateColor={updateWallColor} applyColor={applyColorTo2DWall} />;
    case 'floorColorTab':
      return <FloorTextureTray applyTexture={applyFloorTexturein2DView} />;
    default:
      return null;
  }
};

export const tabsMap = (
  productType: string,
  productId: string,
  includeRecommendations: boolean,
  applyFloorTexturein3DView: Function,
  applyFloorTexturein2DView: Function,
  updateWallColor: Function,
  applyColorTo2DWall: Function,
  builderType: string
) => ({
  designTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('designTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Designs',
  },
  furnitureTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('furnitureTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Products',
  },
  wallsTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('wallsTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Walls',
  },
  lightingTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('lightingTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Lighting',
  },
  floorTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('floorTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Floors',
  },
  doorsTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('doorsTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Doors',
  },
  windowsTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('windowsTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Windows',
  },
  wallColorTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('wallColorTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Wall Color',
  },
  floorColorTab: {
    icon: createIcon(false),
    iconActive: createIcon(true),
    tray: createTray('floorColorTab', applyFloorTexturein3DView, applyFloorTexturein2DView, updateWallColor, applyColorTo2DWall, productType, productId, includeRecommendations, builderType),
    label: 'Floor Color',
  },
});

